<!-- Breadcrumb End -->
<div class="el-breadcrumb-wrapper">
    <div class="container">
        <div class="el-breadcrmb-inner">
            <h1>About us</h1>
            <ul>
                <li>
                    <a href="index.html">home</a>
                </li>
                <li>></li>
                <li>about us</li>
            </ul>
        </div>
    </div>
</div>



<div class="row">
    <div id="cart" class="cart" data-totalitems="0">
        <i class="fas fa-shopping-cart"></i>
    </div>

    <div class="page-wrapper">
        <button id="addtocart">
            Add to Cart
            <span class="cart-item"><img src="../assets/images/all-instructor/reg.png" alt="icon" width="100px"></span>
        </button>
    </div>
</div>


<!-- Breadcrumb Start -->
<!-- <div class="row">





    <div class="el-about-wrapper">
        <h2>
            Olympiad
            <span>Olympiad</span>
            <span>Olympiad</span>
            <span>Powerprep</span>
        </h2>
    </div>
</div> -->



<!-- <div class="el-work-wrapper el-object-wrapper">
    <div class="container">
        <div class="el-work-heading text-center">
            <h4 class="el-top-heading-center">Objectives</h4>
            <h2 class="el-main-heading">My Learning Objectives</h2>
            <p class="el-para">Get latest news in your inbox. Consectetur adipiscing elitadipiscing elitse <br>
                ddo eiusmod tempor incididunt ut labore et dolore.</p>
        </div>
        <div class="row gy-4">
            <div class="col-lg-4 col-md-6">
                <div class="el-work-box el-work-box-1">
                    <div class="el-work-box-inner">
                        <div class="el-work-img">
                            <img src="../assets/images/all-instructor/w1.png" alt="work icon">
                        </div>
                        <div class="el-work-content">
                            <h4>Officially The Best</h4>
                            <p class="el-para">Just in case there is anyone looking
                                for it, new expertise to our knowledge
                                base to make you happy as well.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="el-work-box el-work-box-2">
                    <div class="el-work-box-inner">
                        <div class="el-work-img">
                            <img src="../assets/images/all-instructor/w2.png" alt="work icon">
                        </div>
                        <div class="el-work-content">
                            <h4>Redesigned Website</h4>
                            <p class="el-para">Just in case there is anyone looking
                                for it, new expertise to our knowledge
                                base to make you happy as well.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="el-work-box el-work-box-3">
                    <div class="el-work-box-inner">
                        <div class="el-work-img">
                            <img src="../assets/images/all-instructor/w3.png" alt="work icon">
                        </div>
                        <div class="el-work-content">
                            <h4>We Are Launching</h4>
                            <p class="el-para">Just in case there is anyone looking
                                for it, new expertise to our knowledge
                                base to make you happy as well.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->